import { apiClient } from './api'

export type DocStatus = 'not_started' | 'in_progress' | 'completed'
export type DecisionStatus = 'pending' | 'approved' | 'rejected'

export interface GateItem {
  id: number
  gate_id: number
  kind: 'document' | 'decision'
  name: string
  description: string | null
  status: DocStatus | DecisionStatus
  owner_id: number | null
  due_date: string | null
  attachment_id: number | null
  attachment_name: string | null
  note: string | null
  decided_by: number | null
  decided_at: string | null
  position: number
}

export interface GateDetail {
  id: number
  project_id: number
  gate_number: string
  name: string
  status: 'pending' | 'in-progress' | 'in-review' | 'completed' | string
  progress: number
  due_date: string | null
  completed_date: string | null
  approver: string | null
  description: string | null
  documents_total: number
  documents_completed: number
  decisions_total: number
  decisions_approved: number
  submitted_at: string | null
  decided_at: string | null
  decision_note: string | null
}

export interface GatePayload { gate: GateDetail; items: GateItem[] }

export interface GateItemPatch {
  name?: string
  status?: string
  due_date?: string | null
  attachment_id?: number
  clear_attachment?: boolean
  note?: string
}

/** Stage-gate workflow — backend/app/api/v1/endpoints/project_gate_workflow.py */
export const gateWorkflowService = {
  setUpStandard: (projectId: number) =>
    apiClient.post(`/api/v1/projects/${projectId}/gates/standard`).then((r) => r.data as { gates: GateDetail[] }),
  items: (projectId: number, gateId: number) =>
    apiClient.get<GatePayload>(`/api/v1/projects/${projectId}/gates/${gateId}/items`).then((r) => r.data),
  addItem: (projectId: number, gateId: number, body: { kind: 'document' | 'decision'; name: string; due_date?: string }) =>
    apiClient.post<GatePayload>(`/api/v1/projects/${projectId}/gates/${gateId}/items`, body).then((r) => r.data),
  updateItem: (projectId: number, gateId: number, itemId: number, body: GateItemPatch) =>
    apiClient.patch<GatePayload>(`/api/v1/projects/${projectId}/gates/${gateId}/items/${itemId}`, body).then((r) => r.data),
  removeItem: (projectId: number, gateId: number, itemId: number) =>
    apiClient.delete<GatePayload>(`/api/v1/projects/${projectId}/gates/${gateId}/items/${itemId}`).then((r) => r.data),
  submit: (projectId: number, gateId: number) =>
    apiClient.post<GatePayload>(`/api/v1/projects/${projectId}/gates/${gateId}/submit`).then((r) => r.data),
  decide: (projectId: number, gateId: number, decision: 'approved' | 'sent_back', note?: string) =>
    apiClient.post<GatePayload>(`/api/v1/projects/${projectId}/gates/${gateId}/decision`, { decision, note }).then((r) => r.data),
}
